var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignPedestriansEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pedestrians_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M89.998,88H6.002c-3.084,0-5.006-3.346-3.452-6.011L44.548,9.983c1.542-2.644,5.362-2.644,6.904,0 L93.45,81.989C95.004,84.654,93.082,88,89.998,88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48,8c-1.34,0-2.681,0.661-3.452,1.983L2.55,81.989C0.996,84.654,2.918,88,6.002,88h83.995 c3.084,0,5.006-3.346,3.452-6.011L51.452,9.983C50.681,8.661,49.34,8,48,8L48,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,23.868L79.573,78H16.427L48,23.868 M48,9.959c-0.671,0-1.342,0.331-1.728,0.992L4.254,82.992 C3.477,84.326,4.438,86,5.982,86h84.036c1.544,0,2.505-1.674,1.728-3.008L49.728,10.951C49.342,10.289,48.671,9.959,48,9.959 L48,9.959z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 38.5,
    r: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.936,58h6.224c0,1.412,0.457,1.299,3.769,7.455c3.483,6.344,3.54,5.911,1.542,9.545l-8.622-15.306 C40.683,75.32,41,75,37,75l4.711-8.811C45.575,59.28,45.784,59.261,45.936,58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,57c8.66-13.514,7.727-13.904,10.963-14c1.885,0.057,1.941,0.571,5.139,3.084c3.94,2.893,3.655,2.931,3.598,6.11 C57.68,56.019,58.045,55.572,55,57v-6l-3-3v9h-6v-7C40.747,58.108,40.97,57.8,38,57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignPedestriansEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_pedestrians_eu.a2b1090780730cda1a7ee0ac065f0b82.svg";
export { ForwardRef as ReactComponent };